export const maxWidthContainer = "max-w-[1280px] mx-auto";
export const fullWidthContainer = "w-full flex flex-col px-4";
export const mainContent = `${maxWidthContainer} ${fullWidthContainer} gap-8 sm:gap-16 max-xl:px-4`;
export const mainContentSideRail = `xl:max-w-[824px] mx-auto xl:m-0 w-full flex flex-col gap-12 sm:gap-16 px-4 xl:px-0`;
export const partnerKeyBreakpoint = 18;
